<template>
    <div id="main">
        <div id="manu">
            <navigation />
        </div>
        <div id="contentBox">
            <div class="registervideoContainer"></div>
            <div class="w">
                <div class="min-h-screen bg-gray-50 flex flex-col">
                    <!-- 主要内容 -->
                    <main class="flex-grow">
                        <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                            <!-- 页面标题 -->
                            <div class="text-center mb-16">
                                <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                                    选择适合您的会员计划
                                </h2>
                                <p class="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
                                    根据您的需求选择最合适的版本，解锁更多存储空间和高级功能
                                </p>
                            </div>

                            <!-- 价格卡片 -->
                            <div class="pricing-grid">
                <!-- 高级版 -->
                <div class="pricing-card advanced">
                  <div class="card-content">
                    <h3 class="card-title">高级版</h3>
                    <div class="price-section">
                      <span class="price">¥25</span>
                      <span class="period">/月</span>
                    </div>
                    <ul class="features-list">
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">图片：最多10张，每张20MB</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">文件：最多10个，每个50MB</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">笔记：最多50条</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">上传速率：5-10MB/s</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">回收站：保留7天</span>
                      </li>
                    </ul>
                    <button @click="handlePayment('b866b83080a311f08a9c52540025c377', 1)" class="buy-button">
                      立即购买
                    </button>
                  </div>
                </div>

                <!-- 专业版 - 突出显示（热门推荐） -->
                <div class="pricing-card pro featured">
                  <!-- 热门标签 -->
                  <div class="featured-badge">热门</div>
                  <div class="card-content">
                    <h3 class="card-title">订阅版</h3>
                    <div class="price-section">
                      <span class="price">¥29</span>
                      <span class="period">/月</span>
                      <span class="saving">节省20%</span>
                    </div>
                    <ul class="features-list">
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">图片：最多15张，每张30MB</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">文件：最多15个，每个70MB</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">笔记：不限制</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">上传速率：无限制</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">回收站：保留15天</span>
                      </li>
                      <!-- <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">优先客服支持</span>
                      </li> -->
                    </ul>
                    <button @click="handlePayment('55f21148800511f084cc5254001e7c00', 1)" class="buy-button featured">
                      立即购买（推荐）
                    </button>
                  </div>
                </div>

                <!-- 企业版 -->
                <div class="pricing-card enterprise">
                  <div class="card-content">
                    <h3 class="card-title">年费版</h3>
                    <div class="price-section">
                      <span class="price">¥312.20</span>
                      <span class="period">/年</span>
                      <span class="saving">约26/月</span>
                    </div>
                    <ul class="features-list">
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">图片：最多20张，每张50MB</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">文件：最多20个，每个100MB</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">笔记：不限制</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">上传速率：无限制</span>
                      </li>
                      <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">回收站：保留30天</span>
                      </li>
                      <!-- <li class="feature-item">
                        <span class="icon-check"></span>
                        <span class="feature-text">专属客服</span>
                      </li> -->
                    </ul>
                    <button @click="handlePayment('82cad28acc0a11f09a575254001e7c00', 12)" class="buy-button">
                      立即购买
                    </button>
                  </div>
                </div>
              </div>
                        </div>
                    </main>

                    <!-- 页脚 -->
                    <footer class="bg-white border-t border-gray-200 py-8">
                        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <p class="text-center text-gray-500 text-sm">
                                所有支付通过爱发电平台处理，付款后权益将自动生效
                            </p>
                            <p class="text-center text-gray-500 text-sm mt-2">
                                © 2023 笔记应用 版权所有
                            </p>
                        </div>
                    </footer>
                </div>
            </div>
        </div>

        <!-- 支付状态弹窗 -->
        <el-dialog v-model="paymentDialogVisible" title="支付状态" width="30%">
          <div v-if="paymentLoading">
              <el-loading-spinner />
              <p class="mt-2">正在处理支付...</p>
          </div>
          <div v-else-if="paymentSuccess">
              <div class="text-center">
                  <svg class="mx-auto h-12 w-12 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <h3 class="mt-2 text-lg font-medium text-gray-900">支付成功！</h3>
                  <p class="mt-1 text-sm text-gray-500">您的会员权益已生效</p>
                  <p v-if="inviteCode" class="mt-2 text-sm text-gray-600">邀请码：{{ inviteCode }} <el-button size="small" @click="copyInviteCode">复制</el-button></p>
              </div>
          </div>
          <div v-else-if="paymentError">
              <div class="text-center">
                  <svg class="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  <h3 class="mt-2 text-lg font-medium text-gray-900">支付失败</h3>
                  <p class="mt-1 text-sm text-gray-500">{{ paymentErrorMsg }}</p>
              </div>
          </div>
          <div v-else-if="paymentUrl">
              <p>请点击下方链接完成支付：</p>
              <a :href="paymentUrl" target="_blank" class="text-blue-600 hover:underline">前往支付</a>
              <p class="mt-2 text-sm text-gray-500">支付完成后请点击"查询支付结果"，或取消支付</p>
              <el-button @click="checkPaymentResult" class="mt-2">查询支付结果</el-button>
              <el-button @click="cancelPayment" class="mt-2">取消支付</el-button>
          </div>
          <template #footer>
              <el-button @click="paymentDialogVisible = false">关闭</el-button>
          </template>
        </el-dialog>
        <!-- 新增邮箱输入弹窗 -->
        <el-dialog v-model="emailDialogVisible" title="请输入邮箱" width="30%">
          <el-form :model="emailForm" ref="emailFormRef">
              <el-form-item prop="email" :rules="[{ required: true, message: '请输入邮箱', trigger: 'blur' }, { type: 'email', message: '请输入有效的邮箱地址', trigger: 'blur' }]">
                  <el-input v-model="emailForm.email" placeholder="请输入邮箱"></el-input>
              </el-form-item>
          </el-form>
          <template #footer>
              <el-button @click="emailDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmEmail">确认</el-button>
          </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { ElDialog, ElLoadingSpinner, ElMessage, ElButton, ElForm, ElFormItem, ElInput } from 'element-plus';
// 路由实例
const router = useRouter();
// 响应式变量定义
const paymentDialogVisible = ref(false);
const paymentLoading = ref(false);
const paymentSuccess = ref(false);
const paymentError = ref(false);
const paymentErrorMsg = ref('');
const paymentUrl = ref('');
const currentOrderNo = ref('');
const inviteCode = ref(''); // 新增：存储邀请码
const isAdmin = ref(false);
// 新增邮箱输入相关变量
const emailDialogVisible = ref(false);
const emailForm = ref({ email: '' });
const emailFormRef = ref(null);
const pendingPlanId = ref('');
const pendingMonths = ref(1);
const userEmail = ref(''); // 新增：存储已登录用户的邮箱
const currentEmail = ref(''); // 新增：存储当前输入的邮箱
// 新增：存储用户输入的邮箱（用于后续续费）
const storedEmail = ref(localStorage.getItem('paymentEmail') || '');
// 检查用户登录状态并获取邮箱
const checkUserLogin = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.log('无 token，视为未登录');
    return false;
  }
  try {
    const response = await axios.get('https://a.410121.xyz/api/user/me', {
      headers: { 'Authorization': `Bearer ${token}` },
      timeout: 5000  // 防 504
    });
    if (response.data.code === 200) {
      userEmail.value = response.data.data.email;
      console.log('登录检查成功，email:', userEmail.value);
      return true;
    }
    console.log('API 响应 code 非 200，视为未登录');
    return false;
  } catch (err) {
    console.error('获取用户信息失败:', err.message);
    if (err.code === 'ERR_NETWORK' || err.response?.status >= 400) {
      localStorage.removeItem('token');  // 清除无效 token
      ElMessage.warning('登录状态异常，请重新登录');
    }
    return false;
  }
};

// 处理支付（用户端）
const handlePayment = async (planId, months) => {
  const isLoggedIn = await checkUserLogin();
  if (isLoggedIn && userEmail.value) {
    // 已登录，直接使用用户邮箱处理支付
    await processPayment(planId, months, userEmail.value);
  } else {
    // 未登录，显示邮箱输入弹窗
    pendingPlanId.value = planId;
    pendingMonths.value = months;
    emailDialogVisible.value = true;
  }
};
// 确认邮箱输入
const confirmEmail = () => {
  emailFormRef.value.validate(async (valid) => {
    if (valid) {
      await processPayment(pendingPlanId.value, pendingMonths.value, emailForm.value.email);
      emailDialogVisible.value = false;
    }
  });
};
// 处理支付请求
const processPayment = async (planId, months, email) => {
  paymentLoading.value = true;
  paymentSuccess.value = false;
  paymentError.value = false;
  paymentUrl.value = '';
  inviteCode.value = '';
  try {
    const headers = {};
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    // 检查是否是初次购买
    const isFirstPurchase = await checkIsFirstPurchase(email);
    
    const response = await axios.post(
      'https://a.410121.xyz/api/create-payment',
      { 
        planId, 
        month: months, 
        email,
        isFirstPurchase  // 传递是否为初次购买标记
      }, 
      {
        headers,
        timeout: 10000
      }
    );
    
    if (response.data.ec === 200) {
      currentOrderNo.value = response.data.data.order.out_trade_no;
      paymentUrl.value = response.data.data.order.pay_url;
      currentEmail.value = email;
      paymentDialogVisible.value = true;
    } else {
      paymentError.value = true;
      paymentErrorMsg.value = response.data.em || '创建支付订单失败';
      paymentDialogVisible.value = true;
    }
  } catch (err) {
    paymentError.value = true;
    paymentErrorMsg.value = err.response?.data?.em || err.message || '创建支付订单失败';
    paymentDialogVisible.value = true;
  } finally {
    paymentLoading.value = false;
  }
};
// 检查是否是初次购买
const checkIsFirstPurchase = async (email) => {
  try {
    const headers = {};
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    const response = await axios.get(
      `https://a.410121.xyz/api/check-first-purchase?email=${encodeURIComponent(email)}`,
      { headers }
    );
    
    return response.data.ec === 200 && response.data.data.isFirstPurchase;
  } catch (err) {
    console.error('检查初次购买状态失败:', err);
    return false;  // 默认为非初次购买
  }
};

// 检查支付结果并处理回调
const checkPaymentResult = async () => {
  if (!currentOrderNo.value) return;
  paymentLoading.value = true;
  try {
    const headers = {};
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    // 查询订单时获取是否为初次购买的信息
    const emailParam = currentEmail.value || (token ? '' : '');
    const queryUrl = emailParam
      ? `https://a.410121.xyz/api/query-order?outTradeNo=${currentOrderNo.value}&email=${encodeURIComponent(emailParam)}`
      : `https://a.410121.xyz/api/query-order?outTradeNo=${currentOrderNo.value}`;
      
    const response = await axios.get(queryUrl, {
      headers,
      timeout: 10000
    });
    
    if (response.data.ec === 200) {
      const order = response.data.data.order;
      // 检查是否是初次购买
      const isFirstPurchase = response.data.data.isFirstPurchase || false;
      
      if (order.status === 2) { // 支付成功状态
        paymentSuccess.value = true;
        paymentUrl.value = '';
        
        // 仅初次购买时设置邀请码并自动发送
        if (isFirstPurchase) {
          inviteCode.value = order.invite_code || '';
          // 自动发送邀请码到用户邮箱（由后端处理）
          await sendInviteCodeToEmail(order.invite_code, currentEmail.value);
        }
        
        await refreshUserMembership();
        setTimeout(() => {
          paymentDialogVisible.value = false;
        }, 2000);
      } else if (order.status === 1) {
        paymentError.value = true;
        paymentErrorMsg.value = '支付尚未完成，请继续完成支付';
      } else if (order.status === 0) {
        paymentError.value = true;
        paymentErrorMsg.value = '暂无支付记录，请继续完成支付';
      } else if (order.status === 3) {
        paymentError.value = true;
        paymentErrorMsg.value = '支付已取消';
        paymentUrl.value = '';
        setTimeout(() => {
          paymentDialogVisible.value = false;
        }, 2000);
      } else {
        paymentError.value = true;
        paymentErrorMsg.value = '暂无支付记录，请检查订单号';
      }
    } else {
      paymentError.value = true;
      paymentErrorMsg.value = response.data.em || '查询支付结果失败';
    }
  } catch (err) {
    paymentError.value = true;
    paymentErrorMsg.value = err.response?.data?.em || err.message || '查询支付结果失败';
  } finally {
    paymentLoading.value = false;
  }
};

// 发送邀请码到用户邮箱（前端仅触发，实际发送由后端处理）
const sendInviteCodeToEmail = async (code, email) => {
  if (!code || !email) return;
  
  try {
    const headers = {};
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    await axios.post(
      'https://a.410121.xyz/api/send-invite-code',
      { inviteCode: code, email },
      { headers }
    );
    
    console.log('邀请码已发送到用户邮箱');
  } catch (err) {
    console.error('发送邀请码失败:', err);
    // 仅在控制台报错，不影响用户流程
  }
};
// 取消支付（优化：只两种判断，捕获所有错误包括404）
const cancelPayment = async () => {
  if (!currentOrderNo.value) return;
  paymentLoading.value = true;
  try {
    const headers = {};
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.post(
      'https://a.410121.xyz/api/cancel-payment',
      { outTradeNo: currentOrderNo.value },
      {
        headers,
        timeout: 10000
      }
    );
    // 检查响应：ec===200 为成功
    if (response.data.ec === 200) {
      paymentError.value = true;
      paymentErrorMsg.value = '支付已取消';
      paymentUrl.value = '';
      inviteCode.value = ''; // 重置邀请码
      setTimeout(() => {
        paymentDialogVisible.value = false;
      }, 2000);
    } else {
      // 非200 视为失败
      throw new Error(response.data.em || '取消支付失败');
    }
  } catch (err) {
    // 统一处理所有错误（包括404、超时等），不暴露 raw 消息
    paymentError.value = true;
    paymentErrorMsg.value = '取消支付失败，请稍后重试或联系客服';
  } finally {
    paymentLoading.value = false;
  }
};
// 复制邀请码
const copyInviteCode = async () => {
  try {
    await navigator.clipboard.writeText(inviteCode.value);
    ElMessage.success('邀请码已复制到剪贴板');
  } catch (err) {
    ElMessage.error('复制失败，请手动复制');
  }
};
// 刷新用户会员信息
const refreshUserMembership = async () => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      await axios.get('https://a.410121.xyz/api/user/me', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      ElMessage.success('会员信息已更新');
    }
  } catch (err) {
    console.error('刷新会员信息失败:', err);
  }
};
// 管理员功能：获取待支付订单
const fetchPendingPayments = async () => {
  if (!checkAdminLogin()) return;
  listLoading.value = true;
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.get(
      'https://a.410121.xyz/api/admin/pending-payments',
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000
      }
    );
    if (response.data.code === 200) {
      pendingPayments.value = response.data.data;
    } else {
      throw new Error(response.data.message || '获取待支付订单失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.message || err.message || '获取待支付订单失败');
  } finally {
    listLoading.value = false;
  }
};
// 管理员功能：查询订单详情
const queryOrderDetails = async (outTradeNo) => {
  if (!checkAdminLogin()) return;
  try {
    const token = localStorage.getItem('adminToken');
    const response = await axios.get(
      `https://a.410121.xyz/api/admin/query-order?outTradeNo=${outTradeNo}`,
      {
        headers: { 'Authorization': `Bearer ${token}` },
        timeout: 10000
      }
    );
    if (response.data.ec === 200) {
      orderDetails.value = response.data.data.order;
      orderDetailsVisible.value = true;
    } else {
      throw new Error(response.data.em || '查询订单详情失败');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.em || err.message || '查询订单详情失败');
  }
};
// 格式化订单状态
const formatOrderStatus = (status) => {
  const statusMap = {
    0: { text: '待支付', color: 'warning' },
    1: { text: '处理中', color: 'info' },
    2: { text: '已支付', color: 'success' },
    3: { text: '已取消', color: 'danger' },
    4: { text: '已退款', color: 'gray' }
  };
  return statusMap[status] || { text: '未知', color: 'gray' };
};
// 页面初始化
onMounted(() => {
  // 检查是否为管理员页面
  const path = router.currentRoute.value.path;
  isAdmin.value = path.includes('/admin');
 
  // 管理员页面加载待支付订单
  if (isAdmin.value) {
    fetchPendingPayments();
  }
});
</script>

<style scoped>
.w {
    width: 1700px;
    margin: 0 auto;
}

img {
    width: 100%;
    height: 100%;
    display: block;
}

#home {
    width: 100%;
}

#contentBox {
    width: 100%;
    min-height: 100vh;
    background-repeat: no-repeat;
    margin-left: 200px;
}

.registervideoContainer {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin-left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
    background-image: url(../assets/2.jpg);
    filter: blur(6px);
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: visible;
}

.footer {
    display: flex;
    justify-content: flex-end;
}

button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    background-color: #007bff;
    color: white;
    cursor: pointer;
}

button:hover {
    background-color: #0056b3;
}

button:disabled {
    background-color: #a0cfff;
    cursor: not-allowed;
}

/* 新增：支付页面专用样式，横向排列，卡片大小适中 */
.payment-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.pricing-grid {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    gap: 16px;
    flex-wrap: nowrap; /* 强制横向不换行 */
    margin-bottom: 64px;
    overflow-x: auto; /* 小屏允许横向滚动 */
    padding-bottom: 10px;
}

.pricing-card {
    flex: 0 0 300px; /* 固定宽度，横向排列 */
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    position: relative;
    border-top: 4px solid #3b82f6; /* 默认蓝边 */
    min-width: 300px;
}

.pricing-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.pricing-card.pro {
    border-top-color: #10b981; /* 绿边 */
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    flex: 0 0 320px; /* 热门卡片稍宽 */
    min-width: 320px;
}

.pricing-card.pro:hover {
    transform: translateY(-8px);
}

.pricing-card.enterprise {
    border-top-color: #8b5cf6; /* 紫边 */
}

.featured-badge {
    position: absolute;
    top: 16px;
    right: 16px;
    background: #fbbf24;
    color: black;
    padding: 4px 12px;
    border-radius: 6px 0 0 6px;
    font-size: 12px;
    font-weight: bold;
    z-index: 1;
}

.card-content {
    padding: 24px;
    text-align: center;
}

.card-title {
    font-size: 18px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 16px;
}

.price-section {
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.price {
    font-size: 36px;
    font-weight: bold;
    color: #111827;
}

.period {
    margin-left: 8px;
    color: #6b7280;
    font-size: 16px;
}

.saving {
    margin-left: 8px;
    color: #10b981;
    font-size: 14px;
    font-weight: 600;
}

.features-list {
    list-style: none;
    padding: 0;
    margin: 0 0 32px 0;
    text-align: left;
}

.feature-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
}

.icon-check {
    width: 20px;
    height: 20px;
    color: #10b981;
    margin-right: 12px;
    margin-top: 2px;
    flex-shrink: 0;
}

.icon-check::before {
    content: '✓';
    font-size: 16px;
    font-weight: bold;
}

.feature-text {
    color: #4b5563;
    font-size: 14px;
}

.buy-button {
    width: 100%;
    background: #3b82f6;
    color: white;
    border: none;
    padding: 12px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease;
    font-size: 16px;
}

.buy-button:hover {
    background: #2563eb;
}

.buy-button.featured {
    background: #10b981;
}

.buy-button.featured:hover {
    background: #059669;
}

.footer-note {
    text-align: center;
}

@media screen and (max-width: 1600px) {
    .w {
        max-width: 1400px;
    }

    .pricing-grid {
        gap: 12px;
    }

    .pricing-card {
        flex: 0 0 280px;
        min-width: 280px;
    }

    .pricing-card.pro {
        flex: 0 0 300px;
        min-width: 300px;
    }
}

@media screen and (max-width: 1400px) {
    .w {
        max-width: 1200px;
    }

    .registervideoContainer {
        margin-left: -2%;
    }

    .pricing-grid {
        gap: 10px;
    }

    .pricing-card {
        flex: 0 0 260px;
        min-width: 260px;
    }

    .pricing-card.pro {
        flex: 0 0 280px;
        min-width: 280px;
    }
}

@media screen and (max-width: 1200px) {
    .w {
        max-width: 1000px;
    }

    .pricing-grid {
        gap: 8px;
        justify-content: flex-start;
    }

    .pricing-card {
        flex: 0 0 240px;
        min-width: 240px;
    }

    .pricing-card.pro {
        flex: 0 0 260px;
        min-width: 260px;
    }
}

@media screen and (max-width: 1000px) {
    .w {
        max-width: 100%;
    }

    .registervideoContainer {
        margin-left: 0;
    }

    #contentBox {
        margin-left: 0;
    }

    .payment-container {
        padding: 0 16px;
    }

    .pricing-grid {
        justify-content: center;
        gap: 12px;
    }

    .pricing-card {
        flex: 0 0 280px;
        min-width: 280px;
    }

    .pricing-card.pro {
        flex: 0 0 300px;
        min-width: 300px;
    }
}

@media screen and (max-width: 550px) {
    .w {
        max-width: 100%;
    }

    .registervideoContainer {
        margin-left: 0;
    }

    .edit-container {
        padding: 10px;
    }

    input,
    textarea {
        padding: 8px;
    }

    button {
        padding: 8px 16px;
    }

    .preview-item {
        width: 150px;
    }

    .preview-img {
        height: 100px;
    }

    .card-content {
        padding: 20px;
    }

    .price {
        font-size: 32px;
    }

    .pricing-grid {
        flex-direction: row;
        overflow-x: auto;
        gap: 8px;
    }

    .pricing-card {
        flex: 0 0 250px;
        min-width: 250px;
    }

    .pricing-card.pro {
        flex: 0 0 270px;
        min-width: 270px;
    }
}
</style>